"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tableData = [{
  specified: "Control panel nameplates",
  product: "Panel & equipment nameplates",
  standards: "UL 508A marking conventions"
}, {
  specified: "Arc flash warning labels",
  product: "Arc flash labels (from study data)",
  standards: "NFPA 70E, NEC 110.16"
}, {
  specified: "Equipment & field marking",
  product: "Engraved nameplates, legend plates",
  standards: "NEC 110.16, ANSI Z535"
}, {
  specified: "Safety signs & labels",
  product: "Engraved/printed safety labels",
  standards: "ANSI Z535.4"
}, {
  specified: "Defense / marine nameplates",
  product: "MIL-SPEC phenolic",
  standards: "MIL-P-15035, MIL-DTL-15024"
}, {
  specified: "Valve & asset identification",
  product: "Valve tags, asset tags",
  standards: "Facility/owner standards"
}];
export default function WhatSpecifiersSpecify() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="what-specifiers-specify" className="bg-background py-16 md:py-24 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" ref={ref}>
        <div className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-6 tracking-tight">
            What Identification Do Engineers Specify From Evermark?
          </h2>
          
          <p className="text-lg text-muted-foreground font-default mb-10 max-w-3xl">
            Evermark Industrial Solutions produces the identification specifying engineers most often write into a project manual:
          </p>

          <div className="border border-border rounded-lg overflow-hidden mb-8 bg-card shadow-sm">
            <Table>
              <TableHeader className="bg-muted/50">
                <TableRow>
                  <TableHead className="font-default font-semibold text-foreground w-1/3">
                    What's Specified
                  </TableHead>
                  <TableHead className="font-default font-semibold text-foreground w-1/3">
                    Evermark Product
                  </TableHead>
                  <TableHead className="font-default font-semibold text-foreground w-1/3">
                    Relevant Standard(s)
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {tableData.map((row, i) => <TableRow key={i} data-index={i}>
                    <TableCell className="font-default text-foreground font-medium">
                      {row.specified}
                    </TableCell>
                    <TableCell className="font-default text-muted-foreground">
                      {row.product}
                    </TableCell>
                    <TableCell className="font-default text-muted-foreground">
                      {row.standards}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>

          <div className="bg-muted/30 border-l-4 border-primary p-4 rounded-r-md mb-8">
            <p className="text-sm text-muted-foreground font-default leading-relaxed">
              Evermark Industrial Solutions produces marking designed to align with these standards when properly specified; the applicable standard, edition, and required content depend on the project and jurisdiction, which the engineer of record determines.
            </p>
          </div>

          
        </div>
      </div>
    </section>;
}